import PassengerAddRequest, {
  PassengerAddRequestBody,
} from "./passenger-add-request";

const createBody = (request: PassengerAddRequest): PassengerAddRequestBody => {
  return {
    email: request.email,
    firstName: request.firstName,
    lastName: request.lastName,
    mobilePrimary: request.mobilePrimary,
    mobilePrimaryPrefix: request.mobilePrimaryPrefix,
    mobileSecondary: request.mobileSecondary,
    mobileSecondaryPrefix: request.mobileSecondaryPrefix,
    passenger: request.passenger,
    password: request.password,
    username: request.username,
  };
};

const passengerAddRequestFactory = {
  createBody,
};

export default passengerAddRequestFactory;
